import { useState } from 'react'
import { Scope } from '@utils'

type UseNotesResult = {
  searchText: string
  peopleSearchText: string
  scopes: Scope[]
  selectedContactId: string | undefined
  setSearchText: (text: string) => void
  setPeopleSearchText: (text: string) => void
  setScopes: (scopes: Scope[]) => void
  setSelectedContactId: (contactId: string | undefined) => void
}

// État de l'écran Notes : recherche, pastilles et contact choisi. Les notes
// elles-mêmes sont chargées par la liste (organisme Notes), onglet par onglet.
export const useNotes = (): UseNotesResult => {
  const [searchText, setSearchText] = useState('')
  // On the computer the people column has its own search box: one box for
  // both lists emptied the column when a word of a note was typed, and hid
  // the notes of the person found by name.
  const [peopleSearchText, setPeopleSearchText] = useState('')
  // Aucune pastille = « Toutes » : l'écran s'ouvre sur toutes les notes.
  const [scopes, setScopes] = useState<Scope[]>([])
  const [selectedContactId, setSelectedContactId] = useState<string | undefined>(undefined)

  return {
    searchText,
    peopleSearchText,
    scopes,
    selectedContactId,
    setSearchText,
    setPeopleSearchText,
    setScopes,
    setSelectedContactId,
  }
}
